import Location from './Location';

import KaumatuaGraphics from './KaumatuaGraphics';



export default class Kaumatua extends Location {
    constructor() {
        super('kaumatua');
        this.Graphics = KaumatuaGraphics;

    }
    playBackgroundSound() {
        this.scene.get('sounds').setBackgroundSound('kaumatua', 0.04);
    }

    //Unique guide settings for this scene
    guideSettings() {
        return ({
            x: 620,
            y: 300,
            flip: true,
            id: 'guideProfile',
            //When the guide is ready showSpeech bubble
            callback: this.showSpeech
        });
    }

    maramaSpeaker() {
        return ({
            xmlLoader: this.xmlLoader,
            flip: true,
            x: 362,
            y: 318,
        });
    }

    otherSpeaker() {
        return ({
            xmlLoader: this.xmlLoader,
            x: 200,
            y: 275,
            speaker: this.xmlLoader.getSpeaker()
        });
    }





}